import {Component, OnInit, Input} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../../services/auth.service";
import {ApiService} from "../../../services/api.service";

@Component({
  selector: 'app-nonprofits-donors-listing',
  templateUrl: './nonprofits-donors-listing.component.html',
  styleUrls: ['./nonprofits-donors-listing.component.scss'],
  standalone: false
})
export class NonprofitsDonorsListingComponent implements OnInit {

  @Input()
  rows: any[] = [];

  @Input()
  loadingData: boolean = false;

  //Asc = false, Desc = true, sort by Text
  sortedDescCompanyName = false;
  //Asc = false, Desc = true, sort by Text
  sortedDescCity = false;
  //Asc = false, Desc = true, sort by Number
  sortedDescTotalAssets = false;

  constructor(private authService: AuthService, private apiService: ApiService,
              private router: Router, private route: ActivatedRoute) {

  }

  ngOnInit(): void {
  }

  sortTextCompanyName(): void {
    if (!this.sortedDescCompanyName) {
      this.rows = this.apiService.sortTextDesc('companyName', this.rows);
    } else {
      this.rows = this.apiService.sortTextAsc('companyName', this.rows)
    }
    this.sortedDescCompanyName = !this.sortedDescCompanyName
  }

  sortTextCity(): void {
    if (!this.sortedDescCity) {
      this.rows = this.apiService.sortTextDesc('city', this.rows);
    } else {
      this.rows = this.apiService.sortTextAsc('city', this.rows)
    }
    this.sortedDescCity = !this.sortedDescCity;
  }

  sortNumberTotalAssets(): void {
    if (!this.sortedDescTotalAssets) {
      this.rows = this.apiService.sortTextDesc('totalAssets', this.rows);
    } else {
      this.rows = this.apiService.sortTextAsc('totalAssets', this.rows)
    }
    this.sortedDescTotalAssets = !this.sortedDescTotalAssets
  }

  formatZip(inputStr: string): string{
    return this.apiService.formatZipCode(inputStr)
  }
  formatEin(inputStr: string): string{
    return this.apiService.formatEin(inputStr)
  }

  onViewDetails(row: any) {
    const browserUrl = window.location.href;
    if (browserUrl.includes('donors')) {
      //For Donors
      this.router.navigateByUrl(row.nonprofitDonorId ? `/app/search/donors/${row.nonprofitDonorId}/details` : 'home');
    } else {
      //Nonprofits
      this.router.navigateByUrl(row.nonprofitDonorId ? `/app/search/nonprofits/${row.nonprofitDonorId}/details` : 'home');
    }
  }

}
